import type { Dispatch, SetStateAction } from 'react';
import type { PqlPrice } from 'types/PqlPrice';

export const managePqlPriceUpdate = (
  setPqlPrices: Dispatch<SetStateAction<PqlPrice[]>>,
  mspn: string,
  price: number,
  tireMspn: string,
) => {
  setPqlPrices((pqlPrices) => {
    const existingPqlPriceIndex = pqlPrices.findIndex((p) => p.mspn === mspn && p.tireMspn === tireMspn);

    if (existingPqlPriceIndex >= 0) {
      return [
        ...pqlPrices.slice(0, existingPqlPriceIndex),
        {
          ...pqlPrices[existingPqlPriceIndex],
          mspn,
          price,
          tireMspn,
        },
        ...pqlPrices.slice(existingPqlPriceIndex + 1),
      ];
    }
    return [
      ...pqlPrices,
      {
        mspn,
        price,
        tireMspn,
      },
    ];
  });
};
